import { gql } from '@apollo/client';

const oauthCompanyAccountsQuery = () => {
  return {
    query: gql`
      query OAuthCompanyAccounts {
        companyAccountQuery {
          oauthCompanyAccounts {
            vkn
            uid
            bankCode
            bankName
            companyName
            refreshTokenExpiresAtUtc
            refreshTokenRemainingDays
          }
        }
      }
    `,
    variables: {},
  };
};

export default oauthCompanyAccountsQuery;
